import { sortOptions } from "../mocks/sort.mocks"

export const get = (obj, path, def) => {
  const fullPath = path
    .replace(/\[/g, ".")
    .replace(/]/g, "")
    .split(".")
    .filter(Boolean)
  return fullPath.every(everyFunc) ? obj : def
  function everyFunc(step) {
    return !(step && obj && (obj = obj[step]) === undefined)
  }
}

// deep cloning object to avoid object reference
export const deepCloneSimpleObject = obj => {
  if (obj) return JSON.parse(JSON.stringify(obj))
}

// sort any array by A-z, Z-A, date, number
export const sortCollection = (collectionArr, sortDpValue) => {
  const sortingObject = sortOptions[sortDpValue]
  return sortByOrder(collectionArr, sortingObject.key, sortingObject.order)
}

const sortByOrder = (arr, key, order) => {
  return arr?.sort((a, b) => {
    const d1 = key === "date" ? new Date(a[key]) : a[key]
    const d2 = key === "date" ? new Date(b[key]) : b[key]
    if (d1 > d2) {
      return order === "asc" ? 1 : -1
    }
    if (d2 > d1) {
      return order === "asc" ? -1 : 1
    }
    return 0
  })
}

// filter any array based on value and field referring to
export const filterByKey = (arr, key, matchedVal) => {
  return arr && arr?.filter(item => item[key] === matchedVal)
}

export const unitChangeIngredient = (qty, item, prevCount, servingsCount) => {
  const conversionVal = 0.0022046
  if (qty === "g" && item.QuantityUnit === "lbs") {
    return {
      ...item,
      QuantityText: Number((item.QuantityText / conversionVal).toFixed(0)),
      QuantityUnit: qty,
    }
  } else if (qty === "lbs" && item.QuantityUnit === "g") {
    return {
      ...item,
      QuantityText: Number((item.QuantityText * conversionVal).toFixed(3)),
      QuantityUnit: qty,
    }
  } else if (!qty && prevCount && servingsCount) {
    return {
      ...item,
      QuantityText: Number(
        ((item.QuantityText / prevCount) * servingsCount).toFixed(3)
      ),
    }
  } else return item
}
export const deslashify = (origUrl) => {
  const url = origUrl?.trim().endsWith('/') ? origUrl.slice(0, -1) : origUrl;
  return url;
};

export const addTrailingSlash = (url) => {
  url = url?.trim()
  if(!url) return ""
  return url.endsWith("/") ? url : `${url}/` 
}

export function getLinkPath(href){
    let spl = href?.split("/")?.filter(Boolean)
    return href && !href.includes("http://")&&!href.includes("https://")&&!href.includes("mailto") && !/^[A-Za-z]{2}$/.test(spl[0]) ?"/en"+href : href
}

export function getLinkPathStatus(href){
    let spl = href?.split("/")?.filter(Boolean)
    return href && !href.includes("http://")&&!href.includes("https://")&&!href.includes("mailto") && !/^[A-Za-z]{2}$/.test(spl[0]) ? true : false
}